export default __webpack_public_path__ + "static/media/pin.c0ac4f69.png";